import {AfterViewInit, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, ViewChild} from '@angular/core';
import {NgForm, NgModel} from '@angular/forms';

@Component({
  selector: 'arm-form',
  templateUrl: './arm-form.component.html',
  styleUrls: ['./arm-form.component.scss']
})
export class ArmFormComponent implements OnInit, AfterViewInit {

  @ViewChild('armForm') form: NgForm;
  @ContentChildren(NgModel, {descendants: true}) public models: QueryList<NgModel>;

  @Output() submitForm = new EventEmitter();

  @Input() set disableSubmit(disableSubmit: boolean){
    this._disableSubmit = disableSubmit;

    if (this.form || !this.validateForm){
      this._isFormValid();
    }
  }

  @Input() buttonLabel: string;
  @Input() validateForm = true;

  isSubmitDisabled: boolean;
  _disableSubmit;

  constructor() { }

  ngOnInit(): void {
  }

  onSubmit(): any {
/*    this.form.form.markAllAsTouched();
    this._isFormValid();
    console.log(this.form.form.valid);
    console.log(this.isSubmitDisabled);
    if (this.isSubmitDisabled){
      return;
    }*/

    this.submitForm.emit();
  }

  ngAfterViewInit(): void {
    const ngContentModels = this.models.toArray();

    ngContentModels.forEach((model) => {
      this.form.addControl(model);
    });

    if (this.validateForm) {
      setTimeout(() => {
        // this.form.form.updateValueAndValidity();
        this.form.form.statusChanges.subscribe(() => {
          this._isFormValid();
        });

        this._isFormValid();
      }, 0);
    }
  }

  _isFormValid(): void{
    if (!this.validateForm){
      this.isSubmitDisabled = this._disableSubmit;
    }
    else if (this._disableSubmit === undefined && this.validateForm){
      this.isSubmitDisabled = !this.form.form.valid;
    }else{
      this.isSubmitDisabled = !this.form.form.valid || this._disableSubmit;
    }
  }

}
